export const environment = {
  production: true,
  apiUrl: 'http://dev.atp-images-api.aspcore.net'
};
